import store from '@/store/index'

export default {}

/**
 * Returns the full state object of the vehicle tracking module.
 *
 * @returns Object
 */
export const get = () => {
  return store.getters['assets/trackedVehiclesModule/get']
}

/**
 * Returns vehicles that are being tracked.
 *
 * @return Array
 */
export const trackedVehicles = () => {
  return store.getters['assets/trackedVehiclesModule/trackedVehicles']
}

/**
 * Returns a filtered array of vehicles being tracked.
 *
 * @param filter String
 *
 * @return Array
 */
export const trackedVehiclesFiltered = (filter) => {
  const vehicles = store.getters['assets/trackedVehiclesModule/trackedVehicles']
  const vehicleIds = Object.keys(vehicles)
  filter = filter.trim().toLowerCase()
  let filteredVehicles = []

  vehicleIds.forEach(vehicleId => {
    const vehicle = vehicles[vehicleId]

    const reg_no = vehicle.reg_no !== null ? vehicle.reg_no.toLowerCase() : ''
    const fleet_no = vehicle.fleet_no !== null ? vehicle.fleet_no.toLowerCase() : ''
    const client_name = vehicle.client !== null ? vehicle.client.name.toLowerCase() : ''
    const group_name = vehicle.vehicle_group !== null ? vehicle.vehicle_group.name.toLowerCase() : ''

    let imei = ''
    let serial_no = ''

    if (vehicle.telemetry && vehicle.telemetry.device.imei !== null) {
      imei = vehicle.telemetry.device.imei.toLowerCase()
    }

    if (vehicle.telemetry && vehicle.telemetry.device.serial_no !== null) {
      serial_no = vehicle.telemetry.device.serial_no.toLowerCase()
    }

    if (reg_no.indexOf(filter) !== -1 ||
      fleet_no.indexOf(filter) !== -1 ||
      client_name.indexOf(filter) !== -1 ||
      group_name.indexOf(filter) !== -1 ||
      imei.indexOf(filter) !== -1 ||
      serial_no.indexOf(filter) !== -1) {
      filteredVehicles.push(vehicle)
    }
  })

  return filteredVehicles
}

/**
 * Returns the first tracked vehicle or null if none being tracked.
 *
 * @return Object|null
 */
export const trackedVehicle = () => {
  let trackedVehicles = store.getters['assets/trackedVehiclesModule/trackedVehicles']
  let vehicleIds = Object.keys(trackedVehicles)
  if (vehicleIds.length > 0) {
    if (trackedVehicles.hasOwnProperty(vehicleIds[0])) {
      return trackedVehicles[vehicleIds[0]]
    }
  }

  return null
}

/**
 * Returns the requested tracked vehicle or null if it is not being tracked.
 *
 * @param id Integer
 *
 * @return Object|null
 */
export const trackedVehicleById = (id) => {
  let trackedVehicles = store.getters['assets/trackedVehiclesModule/trackedVehicles']
  if (trackedVehicles.hasOwnProperty(id)) {
    return trackedVehicles[id]
  } else {
    return null
  }
}

/**
 * Returns the number of vehicles being tracked.
 *
 * @return Integer
 */
export const trackedVehicleCount = () => {
  return store.getters['assets/trackedVehiclesModule/trackedVehicleCount']
}

/**
 * Returns true if the specified vehicle is being tracked.
 *
 * @param id Integer
 * @param assignedAs String
 *
 * @return Boolean
 */
export const isTracked = (id, assignedAs = 'primary') => {
  const trackedVehicles = store.getters['assets/trackedVehiclesModule/trackedVehicles']
  return trackedVehicles.hasOwnProperty(id) && trackedVehicles[id].unit_assigned_as === assignedAs
}

/**
 * Add a map or array of object vehicles that must be tracked.
 *
 * @param vehicles Array|Map
 */
export const addTrackedVehicles = (vehicles) => {
  store.commit('assets/trackedVehiclesModule/addTrackedVehicles', vehicles)
}

/**
 * Removes an array of vehicles that should no longer be tracked.
 * The array must consist of the id's of the vehicles that no longer
 * requires tracking.
 *
 * @param vehicles Array
 */
export const removeTrackedVehicles = (vehicles) => {
  store.commit('assets/trackedVehiclesModule/removeTrackedVehicles', vehicles)
}

/**
 * Removes all vehicles from being tracked.
 */
export const clearTrackedVehicles = () => {
  store.commit('assets/trackedVehiclesModule/clearTrackedVehicles')
}

/**
 * Clears all vehicles from being tracked.
 */
export const purge = () => {
  store.commit('assets/trackedVehiclesModule/purge')
}

/**
 * Sets the telemetry data for the specified vehicle.
 *
 * @param vehicleId int
 * @param telemetry Object
 */
export const setTelemetry = (vehicleId, telemetry) => {
  store.commit('assets/trackedVehiclesModule/setTelemetry', {
    vehicleId, telemetry
  })
}

/**
 * Sets the analog input configuration for the specified vehicle.
 *
 * @param vehicleId int
 * @param analogInputConfig Object
 */
export const setAnalogInputCfg = (vehicleId, analogInputConfig) => {
  store.commit('assets/trackedVehiclesModule/setAnalogInputCfg', {
    vehicleId, analogInputConfig
  })
}

/**
 * Returns the tracked vehicle's telemetry or null if the vehicle is not found or
 * it doesn't have telemetry data.
 *
 * @param vehicleId Integer
 *
 * @return Object|null
 */
export const getTelemetry = (vehicleId) => {
  let trackedVehicles = store.getters['assets/trackedVehiclesModule/trackedVehicles']
  if (trackedVehicles.hasOwnProperty(vehicleId)) {
    let trackedVehicle = trackedVehicles[vehicleId]
    if (trackedVehicle !== null && trackedVehicle.hasOwnProperty('telemetry')) {
      return trackedVehicle['telemetry']
    }
  }

  return null
}

/**
 * Returns the tracked vehicle's analog input configuration or null if the vehicle is not found or
 * it doesn't have analog input configuration data.
 *
 * @param vehicleId Integer
 *
 * @return Object|null
 */
export const getAnalogInputCfg = (vehicleId) => {
  let trackedVehicles = store.getters['assets/trackedVehiclesModule/trackedVehicles']
  if (trackedVehicles.hasOwnProperty(vehicleId)) {
    let trackedVehicle = trackedVehicles[vehicleId]
    if (trackedVehicle !== null && trackedVehicle.hasOwnProperty('an_inputs')) {
      return trackedVehicle['an_inputs']
    }
  }

  return null
}



// WEBPACK FOOTER //
// ./src/store/assets/vehicles/trackedVehicles.helpers.js